import "whatwg-fetch"
import React, { useCallback, useState } from "react"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import clientFor from "../apollo-client/clientFor"
import { ApolloProvider } from "@apollo/client"
import ClientPage from "./ClientPage"
import Layout from "./Layout"
import Header from "./Header"
import Footer from "./Footer"
import { SelectedPlansContext } from "./SelectedPlansContext"
import {
  TALENT_SEARCH_PLANS,
  PAYROLL_MANAGED_SERVICES_PLANS,
  WORK_PASS_PLAN,
} from "./sections/client/plans"
import SubscriptionForm from "./forms/client/SubscriptionForm"
import useModal from "../components/modal/useModal"
import useCustomToast from "../components/toast/useCustomToast"
import "./base_landing.css"

const LandingApp = ({ defaultUserType = "visitor" }) => {
  const [userType, setUserType] = useState(defaultUserType)
  const [newClientDetails, setNewClientDetails] = useState({})
  const [selectedPlans, setSelectedPlans] = useState([])
  const [SubscriptionModal, toggleSubscriptionModal] = useModal()
  const [Toast, notifyMessage] = useCustomToast("bottom-center")

  const addWorkPassPlan = () => {
    setSelectedPlans([...selectedPlans, WORK_PASS_PLAN])
  }

  const removeWorkPassPlan = () => {
    setSelectedPlans([
      ...selectedPlans.filter((plan) => plan.planType !== "Work Pass"),
    ])
  }

  const addPayrollManagedServicesPlan = () => {
    setSelectedPlans([
      ...selectedPlans,
      PAYROLL_MANAGED_SERVICES_PLANS.plans[0],
    ])
  }

  return (
    <ApolloProvider client={clientFor(`/${userType}/graphql`)}>
      <Router>
        <SelectedPlansContext.Provider
          value={{
            userType: userType,
            setUserType: setUserType,
            selectedPlans: selectedPlans,
            setSelectedPlans: setSelectedPlans,
            newClientDetails: newClientDetails,
            setNewClientDetails: useCallback(setNewClientDetails, []),
            toggleSubscriptionModal: toggleSubscriptionModal,
            addWorkPassPlan: addWorkPassPlan,
            removeWorkPassPlan: removeWorkPassPlan,
            addPayrollManagedServicesPlan: addPayrollManagedServicesPlan,
            TALENT_SEARCH_PLANS: TALENT_SEARCH_PLANS,
            PAYROLL_MANAGED_SERVICES_PLANS: PAYROLL_MANAGED_SERVICES_PLANS,
            WORK_PASS_PLAN: WORK_PASS_PLAN,
            notifyMessage: notifyMessage,
          }}
        >
          <Layout>
            <Header userType={userType} />

            <Switch>
              <Route path="/client">
                <ClientPage userType={userType} />
              </Route>
            </Switch>

            <Footer />

            <SubscriptionModal
              size={userType === "visitor" ? "large" : "medium"}
            >
              <SubscriptionModal.Header>
                Complete My Subscription
              </SubscriptionModal.Header>

              <SubscriptionModal.Body>
                <SubscriptionForm userType={userType} />
              </SubscriptionModal.Body>
            </SubscriptionModal>
          </Layout>

          <Toast />
        </SelectedPlansContext.Provider>
      </Router>
    </ApolloProvider>
  )
}

export default LandingApp
